import Glide from '@glidejs/glide';

(() => {
  'use strict';

  const initTestimonialsSlider = () => {
    const sliders = document.querySelectorAll('.testimonials__slider');
    if (!sliders.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sliders.forEach((sliderEl) => {
      const glide = new Glide(sliderEl, {
        type: 'carousel',
        perView: 3,
        gap: 20,
        autoplay: reducedMotion ? false : 5000,
        hoverpause: true,
        animationDuration: reducedMotion ? 0 : 400,
        breakpoints: {
          768: {
            perView: 1,
            gap: 16,
          },
        },
      });

      glide.mount();
    });
  };

  document.addEventListener('DOMContentLoaded', initTestimonialsSlider);
})();
